"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div") `
  padding: ${props => props.theme.space.content}px;
  margin-bottom: ${props => props.theme.space.big}px;

  ${props => {
    switch (props.type) {
        case "warning":
            return `
          background-color: rgba(255, 196, 0, 0.08);
          border: 1px solid rgba(186, 129, 0, 0.2);
        `;
        case "info":
            return `
          background-color: rgba(20, 153, 206, 0.05);
          border: 1px solid rgba(20, 153, 206, 0.1);
        `;
        case "error":
            return `
          background-color: rgba(154, 0, 0, 0.05);
          border: 1px solid rgba(154, 0, 0, 0.1);
        `;
    }
}} h3 {
    font-size: ${props => props.theme.font.size.small}px;
    margin: 0;
    margin-bottom: ${props => props.theme.space.small}px;
    color: ${props => (props.type === "error" ? props.theme.color.error : props.theme.color.text.default)};
  }

  p {
    font-size: ${props => props.theme.font.size.small}px;
    margin: 0;
    color: ${props => props.theme.color.text.default};
    word-break: break-word;
    line-height: 1.46;
  }
`;
exports.Message = (_a) => {
    var { title, body } = _a, props = __rest(_a, ["title", "body"]);
    return (React.createElement(Container, Object.assign({}, props),
        title && React.createElement("h3", null, title),
        React.createElement("p", null, body)));
};
exports.default = exports.Message;
//# sourceMappingURL=Message.js.map